import Vue from 'vue';
import { $eventsBus } from "@/main";
import Vuex from 'vuex';
import _ from 'lodash';
import { Item } from '@/app/modules/work/classes/Item';
Vue.use(require('vue-cookies'))

Vue.use(Vuex);

class UndoRedoHistory {
	store;
	history = [];
	currentIndex = -1;

	init(store) {
		this.store = store;
	}

	addState(state) {
		// may be we have to remove redo steps
		if (this.currentIndex + 1 < this.history.length) {
			this.history.splice(this.currentIndex + 1);
		}
		this.history.push(state);
		this.currentIndex++;
	}

	updateCurrentState(state) {
		this.history[this.currentIndex] = state;
	}

	undo() {
		if (!this.canUndo) {
			return;
		}
		const prevState = this.history[this.currentIndex - 1];
		// take a copy of the history state
		// because it would be changed during store mutations
		// what would corrupt the undo-redo-history
		// (same on redo)
		this.store.replaceState(_.cloneDeep(prevState));
		this.currentIndex--;
	}

	redo() {
		if (!this.canRedo) {
			return;
		}
		const nextState = this.history[this.currentIndex + 1];
		this.store.replaceState(_.cloneDeep(nextState));
		this.currentIndex++;
	}

	canUndo() { return this.currentIndex !== 0 && this.currentIndex !== -1; }

	canRedo() { return this.history.length !== this.currentIndex + 1; }
}

const undoRedoHistory = new UndoRedoHistory();
Vue.prototype.$undoRedoHistory = Vue.observable(undoRedoHistory);

const undoRedoPlugin = (store) => {
	// initialize and save the starting stage
	undoRedoHistory.init(store);
	let firstState = _.cloneDeep(store.state);
	undoRedoHistory.addState(firstState);

	store.subscribe((mutation, state) => {
		// is called AFTER every mutation
		switch (mutation.type) {
			case "undo":
				undoRedoHistory.undo();
				return;
			case "redo":
				undoRedoHistory.redo();
				return;
			case "addNewStateToHistory":
				//проверка, что произошли изменения
				if (JSON.stringify(undoRedoHistory.history[undoRedoHistory.currentIndex]) !== JSON.stringify(state)) {
					undoRedoHistory.addState(_.cloneDeep(state));
				}
				return;
			case "contentVideoCurrentTime":
			case "showOverlaysLibraryWindow":
				return;
			default:
				undoRedoHistory.updateCurrentState(_.cloneDeep(state));
				return;
		}
	});
}

export const store = new Vuex.Store({
	plugins: [undoRedoPlugin],
	state: {
		//User
		userInfo: {
			sessionId: Vue.$cookies.get("sessionId"),
			id: -1,
			firstName: "",
			lastName: "",
			avatar: "",
			stockAccess: false,
			isSaveOriginalName: true,
			lastWorkspaceSaveTime: null
		},
		variationNamingTemplate: [{
			id: "custom_initial_id",
			name: "custom",
			title: "Custom",
			value: "1",
		}, {
			id: "version",
			name: "version",
			title: "Version",
			value:
			{
				id: 0,
				name: `"v" + %index%`,
				title: `v1,v2,... by Item`,
			},
		}, {
			id: "size",
			name: "size",
			title: "Size",
			value:
			{
				id: 2,
				name: `%f/s/h/p/v%`,
				title: `Symbol`,
			},

		}, {
			id: 'duration',
			name: 'duration',
			title: 'Duration',
			value:
			{
				id: 1,
				name: `%duration% + "s"`,
				title: `Duration + s`,
			},
		}, {
			id: 'language',
			name: 'language',
			title: 'Language',
			value:
				{ id: "WW", name: "WW", title: "WW", fullName: "World wide" },
		},
		],
		videoPreviewPixelsWidth: 0,
		contentVideoCurrentTime: 0,
		//Files
		filesToUpload: [],
		//Items
		items: [],
		renderItems: [],
		deletedObjects: [],
		selectedItem: null,
		selectedPart: null,
		selectedTransitionId: 1,
		mixedParts: [],
		audioParameters: {
			volume: 100,
			musicVolume: 100,
			musicFile: null
		},
		//Boolean parameters
		isMixerStep: false,
		uploadToCloud: false,
		muted: true,
		showDownloadPanel: false,
		showRendersPreviewWindow: false,
		showMusicLibraryWindow: false,
		showEndCardLibraryWindow: false,
		showEndCardEditWindow: false,
		showStickerLibraryWindow: false,
		showOverlaysLibraryWindow: false
	},
	mutations: {
		undo(state) { },
		redo(state) { },
		addNewStateToHistory(state, isCloseAllWindowsBeforeSave) {
			if (isCloseAllWindowsBeforeSave) {
				state.showOverlaysLibraryWindow = false;
			}
		},
		//User workspace from server
		updateStateByUserWorkspace(state, savedState) {
			if (savedState.variationNamingTemplate) {
				state.variationNamingTemplate = savedState.variationNamingTemplate;
			}
			let savedMixedParts = [];
			if (!!savedState.mixedParts) {
				savedMixedParts = savedState.mixedParts;
			}
			savedState.items.forEach(parsedItem => {
				if (parsedItem.loadingParameters && !parsedItem.loadingParameters.loaded) {
					savedMixedParts = savedMixedParts.filter(p => p.parentItemInfo.id !== parsedItem.id);
					return;
				}
				let newItem = Item.copyFromParsed(parsedItem);
				state.items.push(newItem);
			});
			let allParts = state.items.reduce(
				(acc, val) => acc.concat(val.parts),
				[]
			);
			state.mixedParts = savedMixedParts.map(p => allParts.find(part => part.id === p.id));
			state.renderItems = savedState.renderItems;
			state.selectedItem = state.items.length !== 0 ? state.items[0] : null;
			if (savedState.audioParameters) {
				state.audioParameters = savedState.audioParameters;
			}

			state.muted = savedState.muted;
			state.showDownloadPanel = savedState.showDownloadPanel;
		},
		videoPreviewPixelsWidth(state, videoPreviewPixelsWidth) {
			state.videoPreviewPixelsWidth = videoPreviewPixelsWidth;
		},
		contentVideoCurrentTime(state, contentVideoCurrentTime) {
			state.contentVideoCurrentTime = contentVideoCurrentTime;
		},
		renderItems(state, renderItems) {
			state.renderItems = renderItems;
		},
		//Files
		updateFilesToUpload(state, files) {
			state.filesToUpload = files;
		},
		//Items
		//DEPRECATED. Delete this method
		itemsUploaded(state, data) {
			let isStartUploading = state.items.length === 0;

			data.forEach(uploadedFile => {
				if (uploadedFile.type !== "video") {
					return;
				}
				let item = new Item();

				item.loadingParameters.loaded = true
				item.loadingParameters.process = 100;

				item.fileId = uploadedFile.fileId;
				item.name = uploadedFile.name;
				item.src = uploadedFile.file;
				item.isOutsize = uploadedFile.R.length === 2;
				//item.inputSize = JSON.parse(JSON.stringify(Item.getVideoSize(uploadedFile.R)));

				item.fps = uploadedFile.fps;
				item.duration = uploadedFile.duration;
				item.size = uploadedFile.size;
				item.bitrate = uploadedFile.bitrate;

				item.innerVideoResolutionX = parseInt(uploadedFile.resolution_x);
				item.innerVideoResolutionY = parseInt(uploadedFile.resolution_y);
				item.thumbs = uploadedFile.thumbs;

				if (item.duration < 15) {
					item.autocutParameters.partsCount = 1;
					item.autocutParameters.partsDurations = Math.floor(item.duration / 2);
				} else {
					item.autocutParameters.partsCount = 3;
					item.autocutParameters.partsDurations = 5;
				}

				//item.addNewVariation(state.userInfo.isSaveOriginalName, JSON.parse(JSON.stringify(state.variationNamingTemplate)));

				if (isStartUploading) {
					state.items.push(item);
				} else {
					state.items.push(item);
				}
			});
			if (isStartUploading) {
				state.selectedItem = state.items[0];
			}
		},
		updateItemsAfterUpload(state, data) {
			data.files.forEach(uploadedFile => {
				/* if (uploadedFile.type !== "video") {
					return;
				} */
				let item = state.items.find(i => i.loadingParameters.uploadingId === data.uploadingId);
				if (!item) {
					return
				}

				item.loadingParameters.loaded = true
				item.loadingParameters.process = 100;

				item.fileId = uploadedFile.fileId;
				item.name = uploadedFile.name;
				item.src = uploadedFile.file;
				item.isOutsize = uploadedFile.R.length === 2;
				//item.inputSize = JSON.parse(JSON.stringify(Item.getVideoSize(uploadedFile.R)));

				item.fps = uploadedFile.fps;
				item.duration = uploadedFile.duration;
				item.size = uploadedFile.size;
				item.bitrate = uploadedFile.bitrate;

				item.innerVideoResolutionX = parseInt(uploadedFile.resolution_x);
				item.innerVideoResolutionY = parseInt(uploadedFile.resolution_y);
				item.thumbs = uploadedFile.thumbs;

				if (item.duration < 15) {
					item.autocutParameters.partsCount = 1;
					item.autocutParameters.partsDurations = Math.floor(item.duration / 2);
				} else {
					item.autocutParameters.partsCount = 3;
					item.autocutParameters.partsDurations = 5;
				}

				let parentItemInfo = item.parseToShortObject();
				item.parts.forEach(part => {
					part.parentItemInfo = parentItemInfo;
				});
			});
		},
		deleteItem(state, item) {
			state.items.splice(state.items.indexOf(item), 1);
			state.mixedParts = state.mixedParts.filter(p => p.parentItemInfo.id !== item.id);
			if (state.isMixerStep && state.items.length === 0) {
				state.isMixerStep = false;
			}
			if (state.selectedPart && state.selectedPart.parentItemInfo.id === item.id) {
				state.selectedPart = null;
				if (state.isMixerStep && state.mixedParts.length !== 0) {
					state.selectedPart = state.mixedParts[0];
				}
			}
			if (state.selectedItem === item && state.items.length === 0) {
				state.selectedItem = null;
				state.contentVideoCurrentTime = 0;
			} else {
				//TODO понять почему иначе смена не происходит
				setTimeout(() => {
					state.selectedItem = state.items[0];
				}, 50);

			}
		},
		undoDeleteObjects(state) {
			/* 			let lastIndex = state.deletedObjects.length - 1;
						if (lastIndex === -1) {
							return;
						}
						state.deletedObjects[lastIndex].forEach(o => {
							if (o instanceof Item) {
								state.items.push(o)
							} else if (o instanceof ItemVariation) {
								o.parentItem.variations.push(o);
								if (o.parentItem.variations.every((v) => v.checked)) {
									o.parentItem.checked = true;
								} else {
									o.parentItem.checked = false;
								}
							}
						});
						state.deletedObjects.splice(lastIndex, 1);
						if (state.selectedItem === null) {
							state.selectedItem = state.items[0];
						} */
		},
		changeSelectItem(state, item) {
			state.selectedItem = item;
		},
		changeSelectedPart(state, part) {
			state.selectedPart = part;
		},
		changeSelectedTransitionId(state, id) {
			state.selectedTransitionId = id;
		},
		uploadToCloud(state, isUploadToCloud) {
			state.uploadToCloud = isUploadToCloud;
		},
		muted(state, isMuted) {
			state.muted = isMuted;
		},
		isMixerStep(state, isMixerStep) {
			state.isMixerStep = isMixerStep;
		},
		mixedParts(state, mixedParts) {
			state.mixedParts = mixedParts;
		},
		//Boolean parameters
		showDownloadPanel(state, isShow) {
			state.showDownloadPanel = isShow;
		},
		showRendersPreviewWindow(state, isShow) {
			state.showRendersPreviewWindow = isShow;
		},
		showMusicLibraryWindow(state, isShow) {
			state.showMusicLibraryWindow = isShow;
		},
		showEndCardLibraryWindow(state, isShow) {
			state.showEndCardLibraryWindow = isShow;
		},
		showEndCardEditWindow(state, isShow) {
			state.showEndCardEditWindow = isShow;
		},
		showStickerLibraryWindow(state, isShow) {
			state.showStickerLibraryWindow = isShow;
		},
		showOverlaysLibraryWindow(state, isShow) {
			state.showOverlaysLibraryWindow = isShow;
		}
	},
	getters: {
		isLoggedIn: state => state.userInfo.sessionId !== null,
		videoPreviewPixelsWidth: state => {
			return state.videoPreviewPixelsWidth;
		},
		//Files
		filesToUpload: state => {
			return state.filesToUpload;
		},
		//Tables
		items: state => {
			return state.items;
		},
		selectedItem: state => {
			return state.selectedItem;
		},
		selectedPart: state => {
			return state.selectedPart;
		},
		uploadToCloud: state => {
			return state.uploadToCloud;
		},
		//Boolean parameters
		showDownloadPanel: state => {
			return state.showDownloadPanel;
		},
		showRendersPreviewWindow: state => {
			return state.showRendersPreviewWindow;
		},
		showMusicLibraryWindow: state => {
			return state.showMusicLibraryWindow;
		},
		showEndCardLibraryWindow: state => {
			return state.showEndCardLibraryWindow;
		},
		showEndCardEditWindow: state => {
			return state.showEndCardEditWindow;
		},
		showStickerLibraryWindow: state => {
			return state.showStickerLibraryWindow;
		},
		showOverlaysLibraryWindow: state => {
			return state.showOverlaysLibraryWindow;
		}
	},
	actions: {}
});